import { render, staticRenderFns } from "./TrainInfo.vue?vue&type=template&id=1faaa828&scoped=true&"
import script from "./TrainInfo.vue?vue&type=script&lang=ts&"
export * from "./TrainInfo.vue?vue&type=script&lang=ts&"
import style0 from "./TrainInfo.vue?vue&type=style&index=0&id=1faaa828&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faaa828",
  null
  
)

export default component.exports